class CollectionSort extends HTMLElement {

  constructor() {
    super();

    // detect if sorting is changed
    document.querySelector('#sort-by').addEventListener('change', function(e) {

      // get value of the selected radio button
      var value = e.target.value;

      // update search parameters
      var searchParams = new URLSearchParams(window.location.search);
      searchParams.set("sort_by", value);
      window.location.search = searchParams.toString();

    });

  }
}

if (!customElements.get('collection-sort')) {
  customElements.define('collection-sort', CollectionSort);
}
